import { Component, OnDestroy, OnInit } from '@angular/core'
import { MatTableDataSource } from '@angular/material'
import { Subscription } from 'rxjs/Subscription'
import { PageEvent } from '@angular/material'
import { OriginService } from '../origin.service'
import { OriginModel } from '../models/origin.model'
import { fuseAnimations } from '../../../../../core/animations'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/switchMap'

@Component({
  selector: 'app-origin-list',
  templateUrl: './origin-list.component.html',
  styleUrls: ['./origin-list.component.scss'],
  animations: fuseAnimations,
})
export class OriginListComponent implements OnInit, OnDestroy {
  searchInput: string
  origins: OriginModel[]
  currentOrigin: OriginModel
  onFilterChanged: Subscription
  onUserChanged: Subscription
  pageIndex: number
  totalOrigins: number
  limit: number
  displayedColumns = ['name']
  dataSource: any

  constructor(private originService: OriginService) {}

  ngOnInit() {
    this.onFilterChanged = this.originService.onFilterChanged
      .switchMap(() => this.originService.list())
      .map(response => {
        this.totalOrigins = response.pagination.total_results
        this.origins = response.rows //.rows;
        this.dataSource = new MatTableDataSource<OriginModel>(this.origins)
      })
      .subscribe()

    this.onUserChanged = this.originService.onOriginChanged.subscribe(origin => {
      if (origin == undefined) {
        this.displayedColumns = ['name', 'description', 'created_by', 'created_on']
      } else {
        this.displayedColumns = ['name', 'description']
      }
      this.currentOrigin = origin
    })
  }

  ngOnDestroy() {
    this.onFilterChanged.unsubscribe()
    this.onUserChanged.unsubscribe()
  }

  /**
   *
   * @param {OriginModel} origin
   */
  readOrigin(origin: OriginModel) {
    this.originService.setOrigin(origin)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/system/origins/origin-list/origin-list.component.ts